import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetMyTopGames } from "../../api-clients/gamesClient";

function useMyTopGamesQuery({
  page,
  limit = 3,
}: { limit?: number; page?: number } = {}) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.GAME.MY_TOP_GAMES],
    queryFn: () => handleGetMyTopGames(limit, page),
  });

  return query;
}

export default useMyTopGamesQuery;
